export default function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_isString.js
// module id = 108
// module chunks = 2 3 4 5 6 7 8 10